import { useContext } from "react";

import { SearchContext } from "./Search.context";

export function useSearchContext() {
  return useContext(SearchContext);
}
